<template>
  <div v-if="!selecionouDefesaComercial">
    <div class="defesa-comercial-container" v-for="subimposto in imposto.dados">
      <RadioButton :imposto="subimposto" :seleciona="seleciona" />
      <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
        <Cabecalho
          :tipo="'link'"
          :titulo="subimposto.label"
          :aliquota="subimposto.medida_aplicada"
        />
        <div class="separador" />

        <Ncm :ncm="subimposto.ncm" />
        <div v-if="subimposto.ncm" class="separador" />

        <Descricao :titulo="'Descrição'" :descricao="subimposto.descricao" />
        <GrupoNotificacao v-if="subimposto" :registro="subimposto" />

        <div
          v-if="
            subimposto.descricao ||
              subimposto.obs_aplic ||
              subimposto.obs_inaplic ||
              subimposto.obs ||
              subimposto.nota
          "
          class="separador"
        />

        <Cabecalho tipo="data" :titulo="'Vigência'" :aliquota="subimposto.vigencia_fim" />
        <div v-if="subimposto.vigencia_fim && subimposto.base_legal" class="separador" />

        <BaseLegal :base_legal="subimposto.base_legal" />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="defesa-comercial-container">
      <EditButton v-if="imposto.dados.length > 1" :edita="edita" :classe="imposto.classe" />
      <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
        <Cabecalho
          :tipo="'link'"
          :titulo="registroSelecionado.label"
          :aliquota="registroSelecionado.medida_aplicada"
        />
        <div class="separador" />

        <Ncm :ncm="registroSelecionado.ncm" />
        <div v-if="registroSelecionado.ncm" class="separador" />

        <Descricao :titulo="'Descrição'" :descricao="registroSelecionado.descricao" />
        <GrupoNotificacao v-if="registroSelecionado" :registro="registroSelecionado" />

        <div
          v-if="
            registroSelecionado.descricao ||
              registroSelecionado.obs_aplic ||
              registroSelecionado.obs_inaplic ||
              registroSelecionado.obs ||
              registroSelecionado.nota
          "
          class="separador"
        />

        <Cabecalho tipo="data" :titulo="'Vigência'" :aliquota="registroSelecionado.vigencia_fim" />
        <div
          v-if="registroSelecionado.vigencia_fim && registroSelecionado.base_legal"
          class="separador"
        />

        <BaseLegal :base_legal="registroSelecionado.base_legal" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

export default {
  name: "RegistrosDefesaComercial",

  props: {
    id: String | Number,
    imposto: Object | Array,
    registroSelecionado: Object,
    selecionouDefesaComercial: Boolean,
    seleciona: Function,
    edita: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    GrupoNotificacao,
    EditButton,
    Ncm,
    Notificacao,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },

  created() {
    if (this.imposto.dados.length == 1) {
      this.seleciona(this.imposto.dados[0]);
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.defesa-comercial-container {
  display: flex;

  a {
    color: var(--importacao) !important;
  }
}
</style>
